import { Cart } from './cart'
import { API } from '@/api'

export const cart = new Cart({
  autoSync: false,
  requests: {
    list: () => API.cart.list(),
    put: data => API.cart.put(data),
    subscribe: data => API.stockout.subscribeArriveNotice(data)
  }
})
